module.exports = __webpack_public_path__ + "static/media/spinning-saving-arrows.62af029d.svg";